<template>
  <div>
    <b-row class="py-2">
      <b-col>{{geraet.id}}</b-col>
      <b-col> {{geraet.geraetekennung}}</b-col>
      <b-col>{{geraet.sigfoxDeviceId}}</b-col>
      <b-col>{{(geraetetypen.find(obj => obj.id === geraet.geraetetypId)).titel}}</b-col>
      <b-col><b-button variant="secondary" v-b-toggle="[`geraet-${geraet.id}`]">Bearbeiten</b-button></b-col>
    </b-row>

    <b-collapse :id="`geraet-${geraet.id}`" class="mt-2">
      <b-card>
          <div v-if="adminStatus.adminUpdatingContact" class="text-center">
            <b-spinner variant="warning" type="grow"></b-spinner>
          </div>

          <div v-else>
            <b-button variant="outline-secondary" size="sm" class="float-right" v-b-toggle="[`geraet-${geraet.id}`]" v-b-tooltip.hover title="Abbrechen">X</b-button>
            <b-form @submit.prevent="geraetBearbeiten">
              <b-form-group :id="`geraetekennung-group-${geraet.id}`" label="Name" label-for="geraetekennung">
                <b-form-input
                  :id="`geraetekennung-${geraet.id}`"
                  v-model="geraet.geraetekennung"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
              <b-form-group :id="`sigfoxDeviceId-group-${geraet.id}`" label="SigfoxDevice Id" label-for="sigfoxDeviceId">
                <b-form-input
                  :id="`sigfoxDeviceId-${geraet.id}`"
                  v-model="geraet.sigfoxDeviceId"
                  type="text"
                ></b-form-input>
              </b-form-group>
              <b-form-group :id="`geraetetypdId-group-${geraet.id}`" label="Gerätetyp" label-for="geraetetypId">
                <b-form-select
                  :id="`geraetetypdId-${geraet.id}`"
                  v-model="geraet.geraetetypId"
                >
                  <option v-for="geraetetyp in geraetetypen" :key="geraetetyp.id" :value="geraetetyp.id">{{geraetetyp.titel}}</option>
                </b-form-select>
              </b-form-group>

              <hr>

              <p class="text-left small">mit * gekennzeichnete Felder sind Pflichtfelder</p>

              <b-button
                  v-b-toggle="[`geraet-${geraet.id}`]"
                  variant="secondary"
                  class="mr-3"
                >Abbrechen</b-button>
                <b-button variant="danger" @click="geraetLoeschen">Löschen</b-button>
                <b-button
                  type="submit"
                  variant="success"
                  class="float-right"
                >Speichern</b-button>
            </b-form>
          </div>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'BenutzerKontaktBearbeitenRow',
  props: ['geraet', 'benutzer'],
  computed: {
    ...mapGetters(['adminStatus', 'geraetetypen'])
  },
  methods: {
    ...mapActions(['adminUpdateBenutzerGeraet', 'adminDeleteBenutzerGeraet']),
    geraetBearbeiten() {
      this.adminUpdateBenutzerGeraet({userId: this.benutzer.id, geraet: this.geraet}).then(() => {
        const toastData = {
          title: "",
          msg: "Das Geraet wurde geändert.",
          variant: "success"
        };

        if (this.adminStatus.errMsg) {
          (toastData.title = "Es ist etwas schief gelaufen."),
            (toastData.msg = this.adminStatus.errMsg);
          toastData.variant = "danger";
        }

        this.$emit("updUserToast", toastData);

        // if (!this.adminStatus.errMsg) {
        //   this.$bvModal.hide(`benutzerBearbeiten`);
        // }
      });
    },
    geraetLoeschen() {
      if (
        confirm("Sind Sie sicher, dass Sie das Geraet entgülig löschen wollen?")
      ) {
          this.adminDeleteBenutzerGeraet({userId: this.benutzer.id, geraetId: this.geraet.id}).then(() => {
            const toastData = {
              title: "",
              msg: "Das Geraet wurde gelöscht.",
              variant: "success"
            };

            if (this.adminStatus.errMsg) {
              (toastData.title = "Es ist etwas schief gelaufen."),
                (toastData.msg = this.adminStatus.errMsg);
              toastData.variant = "danger";
            }

            this.$emit("updUserToast", toastData);
          });
      }
    }
  }
}
</script>

<style>

</style>